var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",class:["icon-"+ this.name],attrs:{"width":"100","height":"100","viewbox":"0 0 32 32"}},[_c('use',{staticStyle:{"{'--color1'":"'yellow'}"},attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }